import React, { useState, useEffect, useCallback, useLayoutEffect } from 'react';
import {
    Button,
    Card,
    Col,
    Collapse,
    DatePicker, Divider, Empty,
    Form, Icon,
    Row,
    Select,
    Spin,
} from "antd";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import Widget from '../../../components/Widget';
import moment from "moment";
import tinycolor from 'tinycolor2'
import {
    getFuelMileageReportData,
} from "../../../appRedux/actions/Fuel";
import { connect } from "react-redux";
// import './style.css';
import { fetchAssetFiltersData, searchGlobalAssetData } from "../../../appRedux/actions";
import AssetSearch from "../../../components/AssetSearch";
import PeriodSelector from './PeriodSelector';
import axios from '../../../util/Api'
import { createDebounce } from '../../../util/methods'
import { groupManualData } from '../../DeviceMap/fuel-report/fuelDataGroup';

const { Panel } = Collapse;

const { RangePicker } = DatePicker;

const getValueByName = (array, name) => {
    const item = (array || []).find(obj => obj.name === name);
    return item ? item.value : 0; // Returns undefined if the item is not found
};

const getIdValue = (value) => {
    if (!value) return ''
    if (typeof value === 'string') return value
    if (value._id) return value._id.toString()
    return value.toString ? value.toString() : ''
}

const getStandardFuelRateByMeter = (asset, selectedUnit) => {
    if (!asset || !asset.assetModel || !selectedUnit) return null

    const selectedUnitId = getIdValue(selectedUnit && selectedUnit._id)
    const selectedUnitName = ((selectedUnit && selectedUnit.name) || '').toUpperCase()
    const rates = (asset.assetModel && asset.assetModel.standardFuelConsumptionRate) || []

    const matchedRate = rates.find((rate) => {
        const perType = rate && rate.perType
        const perTypeId = getIdValue(perType && perType._id ? perType._id : perType)
        const perTypeName = ((perType && perType.name) || '').toUpperCase()

        if (selectedUnitId && perTypeId && perTypeId === selectedUnitId) {
            return true
        }
        if (selectedUnitName && perTypeName && perTypeName === selectedUnitName) {
            return true
        }
        return false
    })

    const standardRate = matchedRate && Number(matchedRate.fuelQty)
    if (!standardRate || Number.isNaN(standardRate) || standardRate <= 0) {
        return null
    }
    return standardRate
}


function AssetGroupChart(props) {
    const [selectedAssets, setSelectedAssets] = useState([])
    const [allUnits, setAllUnits] = useState([])
    const [dateRange, setDateRange] = useState({
        startRange: moment().subtract(7, 'days').startOf('day').unix(),
        endRange: moment().subtract(1, 'days').endOf('day').unix(),
        chartGroup: '7d',
        isCustomRange: false,
        customRange: null
    })
    const [unit, setUnit] = useState()
    const [selectedGroup, setSelectedGroup] = useState('d')
    const [chartData, setChartData] = useState({})
    const [chartProcessedData, setChartProcessedData] = useState({})
    const [chart, setChart] = useState(null)
    const [chartType, setChartType] = useState('1')
    const { form, loading, assetFilters, authUser, assetData, assetSearchLoading, fetchAssetFiltersData } = props
    const { getFieldDecorator } = form

    useEffect(() => {
        fetchAssetFiltersData()
    }, [])

    // Consolidated date range effect
    useEffect(() => {
        const now = moment().subtract(1, 'days')
        let startRange = null
        let endRange = null

        if (dateRange.isCustomRange && dateRange.customRange) {
            endRange = dateRange.customRange[1].unix()
            startRange = dateRange.customRange[0].unix()
        } else {
            endRange = now.clone().endOf('day').unix()
            let day = now.clone()
            // console.log('dateRange.chartGroup', dateRange.chartGroup)
            switch (dateRange.chartGroup) {
                case '1d':
                    startRange = now.clone().startOf('day').unix()
                    break
                case '1m':
                    startRange = day.subtract(1, 'months').startOf('day').unix()
                    break
                case '3m':
                    startRange = day.subtract(3, 'months').startOf('day').unix()
                    break
                case '6m':
                    startRange = day.subtract(6, 'months').startOf('day').unix()
                    break
                case '12m':
                    startRange = day.subtract(12, 'months').startOf('day').unix()
                    break
                default: // '7d'
                    startRange = day.subtract(6, 'days').startOf('day').unix()
            }
        }
        // console.log('startRange', moment.unix(startRange).toDate())
        // console.log('endRange', moment.unix(endRange).toDate())
        setDateRange(prev => ({
            ...prev,
            startRange,
            endRange
        }))
    }, [dateRange.chartGroup, dateRange.isCustomRange, dateRange.customRange])

    const handleChartGroupChage = (group, isCustomRange, customRange) => {
        setDateRange(prev => ({
            ...prev,
            chartGroup: group,
            isCustomRange: !!isCustomRange,
            customRange: customRange || null
        }))
    }

    const handleMasterUnitChage = (unit) => {
        setUnit(allUnits.find(u => u._id === unit))
    }

    const handleDataGroup = (group) => {
        setSelectedGroup(group)
    }

    const handleSubmit = e => {
        e.preventDefault()
        e.stopPropagation()

        // Reset all states to default values
        setSelectedAssets([])
        setAllUnits([])
        setUnit(null)
        setChartData({})
        setChartProcessedData({})
        setSelectedGroup('d')
        setChartType('1')

        // If chart exists, dispose it
        if (chart) {
            chart.dispose()
            setChart(null)
        }

        form.validateFields((err, values) => {
            if (err) return

            const payload = {
                location: values.location && [values.location],
                subLocation: values.subLocation && [values.subLocation],
                assetType: values.assetType && [values.assetType],
                assetSubType: values.assetSubType && [values.assetSubType],
                assetModel: values.assetModel && [values.assetModel],
            }

            if (values.asset && values.asset.length > 0) {
                // console.log('values.asset', values.asset)
                payload.assets = values.asset
            }



            axios.post('/asset/organisation/all', payload)
                .then(res => {
                    const { data } = res
                    if (data && data.length > 0) {
                        // console.log('data', data)
                        // const allAssets = data.map(item => item.parent)
                        setSelectedAssets(data)

                        const distinctMeters = [...new Set(data
                            .filter(asset => asset.assetModel && asset.assetModel.meters)
                            .flatMap(asset => asset.assetModel.meters)
                            .map(meter => meter._id))]
                            .map(id => data
                                .flatMap(asset => asset.assetModel && asset.assetModel.meters || [])
                                .find(meter => meter._id === id))

                        setAllUnits(distinctMeters || [])
                        setUnit(distinctMeters && distinctMeters.length > 0 ? distinctMeters[0] : null)
                        // console.log('calling data -')
                        // props.getFuelMileageReportData({
                        //     assets: data.map(asset => asset._id),
                        //     periodFrom: moment.unix(dateRange.startRange).toDate(),
                        //     periodTo: moment.unix(dateRange.endRange).toDate(),
                        //     meter: distinctMeters && distinctMeters.length > 0 ? distinctMeters[0]['_id'] : null,
                        //     chartGroup: dateRange.chartGroup,
                        //     selectedGroup: selectedGroup
                        // })
                    }
                })
                .catch(err => console.log('err', err))
        })
    }

    // useEffect(() => {
    //     // console.log('props.mileage_report_data', props.mileage_report_data)
    // }, [props.mileage_report_data])

    // Create a debounced API call function
    const debouncedFetchData = useCallback(
        createDebounce((assets, startRange, endRange, unit, chartGroup, selectedGroup) => {
            if (!assets.length || !startRange || !endRange || !unit || !chartGroup || !selectedGroup) return
            props.getFuelMileageReportData({
                assets: assets.map(asset => asset._id),
                periodFrom: moment.unix(startRange).toDate(),
                periodTo: moment.unix(endRange).toDate(),
                meter: unit ? unit['_id'] : null,
                chartGroup: dateRange.chartGroup,
                selectedGroup: selectedGroup
            })
        }, 300), // Wait 500ms after last change before making API call
        [] // Empty dependency array since we don't want to recreate this function
    )

    // Monitoring effect that triggers API call
    useEffect(() => {
        debouncedFetchData(selectedAssets, dateRange.startRange, dateRange.endRange, unit, dateRange.chartGroup, selectedGroup)

        // Cleanup function to cancel any pending debounced calls
        return () => {
            debouncedFetchData.cancel()
        }
    }, [selectedAssets, dateRange.startRange, dateRange.endRange, unit, dateRange.chartGroup, selectedGroup, debouncedFetchData])

    useEffect(() => {
        if (!props.mileage_report_data) {
            console.log('No mileage report data available')
            return
        }

        // console.log('props.mileage_report_data', props.mileage_report_data)

        try {
            // Reset chart data when date range changes
            setChartData({})
            setChartProcessedData({})

            // If chart exists, dispose it to clear old data
            if (chart) {
                chart.dispose()
                setChart(null)
            }

            (props.mileage_report_data || []).forEach(reportData => {
                const key = Object.keys(reportData)[0]
                const fuelData = reportData[key]

                if (fuelData && fuelData.length && dateRange.startRange && dateRange.endRange) {
                    // Filter data based on date range first
                    const filteredData = fuelData.filter(f =>
                        moment(f.date).unix() >= dateRange.startRange &&
                        moment(f.date).unix() <= dateRange.endRange
                    )

                    if (filteredData.length === 0) {
                        console.log('No data available for selected date range')
                        return
                    }

                    const groupedData = filteredData.reduce((acc, row) => {
                        const formattedDate = moment(row.date).format('DD-MM-YYYY');
                        if (!acc[formattedDate]) {

                            acc[formattedDate] = {
                                quantity: 0,
                                isFullTank: false,
                            }

                            // Dynamically add meter-specific fields
                            allUnits.forEach(meter => {
                                const meterName = meter.name.toLowerCase()
                                acc[formattedDate][`${meterName}_reading`] = getValueByName(row.currentReading, meter.name.toUpperCase())
                                acc[formattedDate][`${meterName}_consumed`] = 0
                            })
                        }

                        acc[formattedDate].quantity += row.quantity; //sum
                        // acc[formattedDate].hours_consumed += getValueByName(row.consumedReading, 'HOURS'); //sum
                        // acc[formattedDate].kms_consumed += getValueByName(row.consumedReading, 'KMS'); //sum

                        // acc[formattedDate].hours_reading = getValueByName(row.currentReading, 'HOURS') || acc[formattedDate].hours_reading; //only take last value or reading
                        // acc[formattedDate].kms_reading = getValueByName(row.currentReading, 'KMS') || acc[formattedDate].kms_reading;

                        acc[formattedDate].isFullTank = acc[formattedDate].isFullTank || row.isFullTank; // if previous date is full tank then current date is also full tank

                        // Update meter-specific fields
                        allUnits.forEach(meter => {
                            const meterName = meter.name.toLowerCase()
                            // Update consumed values (sum)
                            acc[formattedDate][`${meterName}_consumed`] += getValueByName(row.consumedReading, meter.name.toUpperCase())
                            // Update reading (take last value)
                            acc[formattedDate][`${meterName}_reading`] = getValueByName(row.currentReading, meter.name.toUpperCase()) ||
                                acc[formattedDate][`${meterName}_reading`]
                        })
                        return acc;
                    }, {});

                    // console.log(groupedData);


                    // Convert the grouped data into the desired format
                    const result = Object.entries(groupedData || {}).map(([date, values]) => {
                        // Start with base fields
                        const resultObj = {
                            date,
                            isFullTank: values.isFullTank,
                            quantity: values.quantity,
                        }

                        // Add meter-specific fields and calculations
                        allUnits.forEach(meter => {
                            const meterName = meter.name.toLowerCase()
                            resultObj[`${meterName}_reading`] = values[`${meterName}_reading`]
                            resultObj[`${meterName}_consumed`] = values[`${meterName}_consumed`]

                            // Calculate ratios
                            resultObj[`${meterName}_qty`] = values.quantity ?
                                Number(values[`${meterName}_consumed`]) / Number(values.quantity) : 0

                            resultObj[`qty_${meterName}`] = values[`${meterName}_consumed`] ?
                                Number(values.quantity) / Number(values[`${meterName}_consumed`]) : 0
                        })

                        return resultObj
                    }).filter(item => item.isFullTank)

                    // group d/w/m/y

                    // console.log('result', result);
                    setChartData((prev) => ({
                        ...prev,
                        [key]: result
                    }))
                }
            })
        } catch (error) {
            console.error('Error processing mileage report data:', error)
        }
    }, [props.mileage_report_data]);

    useLayoutEffect(() => {
        // console.log(selectedGroup);
        if (chartData && selectedGroup) {
            if (selectedGroup !== 'd') {
                Object.entries(chartData).flatMap(([assetId, data]) => {
                    const groupData = groupManualData(data, selectedGroup)
                    // console.log(group);
                    setChartProcessedData(prev => ({
                        ...prev,
                        [assetId]: Object.values(groupData)
                    }))
                })
            } else {
                setChartProcessedData(chartData)
            }
        }
        // setData(docs)
    }, [chartData, selectedGroup])


    // useEffect(() => {
    //     console.log('setChartProcessedData', setChartProcessedData)
    // }, [setChartProcessedData])

    const createChart = useCallback((chartData) => {
        if (!unit || !chartData || Object.keys(chartData).length === 0) return

        // Dispose of previous chart instance
        if (chart) {
            chart.dispose()
        }

        // Create chart instance
        const newChart = am4core.create("chartDiv", am4charts.XYChart)
        am4core.useTheme(am4themes_animated)

        // Transform data for amcharts
        const meterName = unit.name.toLowerCase()
        // console.log('meterName', meterName)
        // console.log('chartData', chartData)
        const chartDataArray = Object.entries(chartData).flatMap(([assetId, data]) => {
            const asset = selectedAssets.find(asset => asset._id === assetId)
            const assetName = asset ? `${asset.assetCode || ''} ${asset.ownerCode || ''} - ${asset.name || ''}` : assetId
            const standardFuelRate = getStandardFuelRateByMeter(asset, unit)
            const standardValue =
                chartType === '1'
                    ? standardFuelRate
                    : chartType === '2' && standardFuelRate
                        ? Number(1 / standardFuelRate)
                        : null
            return data.map(item => ({
                asset: assetName,
                date: item.date,
                value: chartType === '1' ? item[`qty_${meterName}`] :
                    chartType === '2' ? item[`${meterName}_qty`] :
                        chartType === '3' ? item[`quantity`] :
                            item[`${meterName}_consumed`],
                standardValue: standardValue && Number.isFinite(standardValue) ? standardValue : null
            }))
        })

        // Sort data by date
        chartDataArray.sort((a, b) => {
            const dateA = moment(a.date, 'DD-MM-YYYY')
            const dateB = moment(b.date, 'DD-MM-YYYY')
            return dateA.valueOf() - dateB.valueOf()
        })
        newChart.data = chartDataArray

        // Create axes
        const dateAxis = newChart.xAxes.push(new am4charts.CategoryAxis())
        dateAxis.dataFields.category = "date"
        dateAxis.renderer.grid.template.location = 0
        dateAxis.renderer.minGridDistance = 50
        dateAxis.title.text = "Date"
        // Update date axis title based on selectedGroup
        switch (selectedGroup) {
            case 'w':
                dateAxis.title.text = "Week"
                break
            case 'm':
                dateAxis.title.text = "Month"
                break
            case 'y':
                dateAxis.title.text = "Year"
                break
            default: // 'd'
                dateAxis.title.text = "Date"
        }
        // Update label rotation and position
        dateAxis.renderer.labels.template.rotation = -90
        dateAxis.renderer.labels.template.horizontalCenter = "right"
        dateAxis.renderer.labels.template.verticalCenter = "middle"
        dateAxis.renderer.labels.template.fontSize = 10 // Add this line to make font smaller

        // Adjust label padding if needed
        // dateAxis.renderer.labels.template.paddingBottom = 10

        const valueAxis = newChart.yAxes.push(new am4charts.ValueAxis())
        // Set dynamic axis title based on chart type and meter unit
        switch (chartType) {
            case '1':
                valueAxis.title.text = `Fuel Consumption (Qty/${meterName})`
                break
            case '2':
                valueAxis.title.text = `Fuel Efficiency (${meterName}/Qty)`
                break
            case '3':
                valueAxis.title.text = `${meterName} Reading`
                break
            case '4':
                valueAxis.title.text = 'Fuel Quantity (Liters)'
                break
            default:
                valueAxis.title.text = 'Value'
        }

        // Style axis titles
        // dateAxis.title.fontWeight = "bold"
        // valueAxis.title.fontWeight = "bold"
        dateAxis.title.marginTop = 20
        valueAxis.title.marginRight = 20

        // Generate distinct colors based on golden ratio
        const generateDistinctColors = (count) => {
            const colors = []
            const hueStep = 0.618033988749895 // Golden ratio conjugate
            let hue = Math.random() // Starting hue

            for (let i = 0; i < count; i++) {
                hue += hueStep
                hue %= 1

                const color = tinycolor({
                    h: hue * 360,
                    s: 0.5 + Math.random() * 0.2, // 50-70% saturation
                    l: 0.4 + Math.random() * 0.2  // 40-60% lightness
                })

                colors.push(color.toHexString())
            }

            return colors
        }

        // Create series for each asset
        const uniqueAssets = [...new Set(chartDataArray.map(item => item.asset))]
        const distinctColors = generateDistinctColors(uniqueAssets.length)
        const primarySeriesList = []
        uniqueAssets.forEach((assetId, index) => {
            const series = newChart.series.push(new am4charts.LineSeries())
            series.dataFields.valueY = "value"
            series.dataFields.categoryX = "date"
            series.name = assetId
            series.strokeWidth = 2
            series.tooltipText = "{name}: [bold]{valueY}[/]"

            series.stroke = am4core.color(distinctColors[index])
            series.fill = series.stroke

            // Add bullets
            let bullet = series.bullets.push(new am4charts.CircleBullet())
            bullet.circle.radius = 4 // Size of the bullet
            bullet.circle.fill = series.stroke // Match line color
            bullet.circle.strokeWidth = 2
            bullet.circle.stroke = am4core.color("#fff") // White border around bullet

            // Optional: Add hover state to bullets
            let hoverState = bullet.states.create("hover")
            hoverState.properties.scale = 1.7 // Bullet becomes larger on hover
            hoverState.properties.opacity = 1

            // Filter data for this asset
            const assetSeriesData = chartDataArray.filter(item => item.asset === assetId)
            series.data = assetSeriesData
            primarySeriesList.push(series)

            // Add standard fuel rate indicator (dashed straight line) for qty/meter or meter/qty modes.
            if (chartType === '1' || chartType === '2') {
                const standardSeriesData = assetSeriesData.filter(item => item.standardValue !== null)
                if (standardSeriesData.length > 0) {
                    const standardSeries = newChart.series.push(new am4charts.LineSeries())
                    standardSeries.dataFields.valueY = "standardValue"
                    standardSeries.dataFields.categoryX = "date"
                    standardSeries.name = `${assetId} - St. fuel consumption rate`
                    standardSeries.strokeWidth = 1.5
                    standardSeries.strokeDasharray = "6,4"
                    standardSeries.stroke = am4core.color(distinctColors[index])
                    standardSeries.fill = standardSeries.stroke
                    standardSeries.tooltipText = "{name}: [bold]{valueY}[/]"
                    standardSeries.data = standardSeriesData
                }
            }
        })

        newChart.cursor = new am4charts.XYCursor()
        newChart.cursor.behavior = "zoomX" // Enable X axis zooming
        newChart.cursor.lineX.strokeWidth = 2
        newChart.cursor.lineX.strokeOpacity = 0.5
        newChart.cursor.lineY.strokeWidth = 2
        newChart.cursor.lineY.strokeOpacity = 0.5

        // Add scrollbar
        const scrollbarX = new am4charts.XYChartScrollbar()
        primarySeriesList.forEach(series => {
            scrollbarX.series.push(series)
        })
        newChart.scrollbarX = scrollbarX
        newChart.scrollbarX.parent = newChart.bottomAxesContainer
        // newChart.scrollbarX.marginBottom = 20

        // Add legend
        newChart.legend = new am4charts.Legend()
        newChart.legend.position = "right"
        newChart.legend.scrollable = true
        newChart.legend.maxHeight = 400
        newChart.legend.markers.template.width = 15
        newChart.legend.markers.template.height = 15
        newChart.legend.itemContainers.template.paddingTop = 5
        newChart.legend.itemContainers.template.paddingBottom = 5

        // Enable chart export menu
        newChart.exporting.menu = new am4core.ExportMenu()
        newChart.exporting.menu.align = "right"
        newChart.exporting.menu.verticalAlign = "top"

        newChart.exporting.filePrefix = `Fuel_Analysis_${moment().format('YYYY-MM-DD')}`
        // Customize export menu items
        newChart.exporting.menu.items = [{
            "label": "...",
            "menu": [
                { "type": "png", "label": "PNG" },
                { "type": "jpg", "label": "JPG" },
                { "type": "csv", "label": "CSV" },
                { "type": "xlsx", "label": "XLSX" },
                { "type": "pdf", "label": "PDF" }
            ]
        }]

        setChart(newChart)
    }, [unit, chartType, selectedAssets, chart])

    // Add useEffect for chart creation/cleanup
    useEffect(() => {
        if (Object.keys(chartProcessedData).length > 0 && unit) {
            createChart(chartProcessedData)
        }

        return () => {
            if (chart) {
                chart.dispose()
            }
        }
    }, [chartProcessedData, unit, chartType])

    useEffect(() => {
        const assetType = form.getFieldValue('assetType')
        if (assetType) {
            // Reset subType and model to 'all' when assetType changes
            form.setFieldsValue({
                assetSubType: 'all',
                assetModel: 'all'
            })
        }
    }, [form.getFieldValue('assetType')])

    return (
        <div>
            <Spin spinning={loading}>
                <Card
                    className={`gx-card-metrics`}
                    title={`Fuel Group Chart`}
                >
                    <Form
                        onSubmit={handleSubmit}
                        className="ant-advanced-search-form"
                        layout="inline"
                        labelAlign="left"
                    >
                        <Row gutter={8}>
                            <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                <Form.Item key={'location'} label={'Location'} style={{ width: '100%' }}>
                                    {getFieldDecorator(`location`, {
                                        rules: [{ required: true, message: `Location is required!` }],
                                    })(<Select
                                        showSearch
                                        showArrow
                                        filterOption={(input, option) =>
                                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                        }
                                        placeholder={`Select Location`}
                                    >
                                        <Select.Option key={'AllLocation'}
                                            value={'all'}>All</Select.Option>
                                        {(authUser && authUser.locations || []).map(item =>
                                            <Select.Option key={item._id}
                                                value={item._id}>{item.name}</Select.Option>)}

                                    </Select>)
                                    }
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                <Form.Item key={'subLocation'} label={'Sub Location'} style={{ width: '100%' }}>
                                    {getFieldDecorator(`subLocation`, {
                                        rules: [{ required: true, message: `Sub Location is required!` }],
                                    })(<Select
                                        showSearch
                                        showArrow
                                        filterOption={(input, option) =>
                                            (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                        }
                                        placeholder={`Select Sub Location`}
                                    >
                                        <Select.Option key={'AllSubLocation'}
                                            value={'all'}>All</Select.Option>
                                        {(authUser && authUser.clients || []).map(item =>
                                            <Select.Option key={item._id}
                                                value={item._id}>{item.name}</Select.Option>)}

                                    </Select>)
                                    }
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                <Form.Item
                                    key={"assetType"}
                                    label={"Asset Type"}
                                    style={{ width: "100%" }}
                                >
                                    {getFieldDecorator(`assetType`, {
                                        onChange: (value) => {
                                            // Reset subType and model when type changes
                                            form.setFieldsValue({
                                                assetSubType: 'all',
                                                assetModel: 'all'
                                            })
                                        }
                                    })(
                                        <Select
                                            showSearch
                                            showArrow
                                            filterOption={(input, option) =>
                                                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                            }
                                            placeholder={`Select Asset Type`}
                                        >
                                            <Select.Option key={'AllType'}
                                                value={'all'}>All</Select.Option>
                                            {(assetFilters && assetFilters.assetTypes || []).map(item =>
                                                <Select.Option key={item._id}
                                                    value={item._id}>{item.name}</Select.Option>)}

                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                <Form.Item
                                    key={"assetSubType"}
                                    label={"Asset Sub Type"}
                                    style={{ width: "100%" }}
                                >
                                    {getFieldDecorator(`assetSubType`, {
                                        onChange: () => {
                                            // Reset model when subType changes
                                            form.setFieldsValue({
                                                assetModel: 'all'
                                            })
                                        }
                                    })(
                                        <Select
                                            showSearch
                                            showArrow
                                            filterOption={(input, option) =>
                                                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                            }
                                            placeholder={`Select Asset Sub Type`}
                                        >
                                            <Select.Option key={'AllSubType'}
                                                value={'all'}>All</Select.Option>
                                            {(assetFilters && assetFilters.assetSubTypes || [])
                                                .filter(item => {
                                                    const selectedAssetType = form.getFieldValue('assetType')
                                                    return selectedAssetType === 'all' || item.assetType === selectedAssetType
                                                })
                                                .map(item =>
                                                    <Select.Option key={item._id}
                                                        value={item._id}>{item.name}</Select.Option>)}

                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                <Form.Item
                                    key={"assetModel"}
                                    label={"Asset Model"}
                                    style={{ width: "100%" }}
                                >
                                    {getFieldDecorator(`assetModel`)(
                                        <Select
                                            style={{ width: "100%" }}
                                            showSearch
                                            showArrow
                                            filterOption={(input, option) =>
                                                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                            }
                                            placeholder={`Select Asset Model`}
                                        >
                                            <Select.Option key={'AllModel'}
                                                value={'all'}>All</Select.Option>
                                            {(assetFilters && assetFilters.assetModels || [])
                                                .filter(item => {
                                                    const selectedAssetType = form.getFieldValue('assetType')
                                                    const selectedAssetSubType = form.getFieldValue('assetSubType')

                                                    // If assetType is 'all', show all models
                                                    if (selectedAssetType === 'all' && selectedAssetSubType === 'all') return true
                                                    if (selectedAssetSubType !== 'all') {
                                                        return item.assetSubType === selectedAssetSubType
                                                    }
                                                    // If type is selected but subtype is 'all', show models for all subtypes of selected type
                                                    if (selectedAssetSubType === 'all') {
                                                        const validSubTypes = assetFilters.assetSubTypes
                                                            .filter(st => st.assetType === selectedAssetType)
                                                            .map(st => st._id)
                                                        return validSubTypes.includes(item.assetSubType)
                                                    }
                                                    // If both type and subtype are selected, show only models for selected subtype
                                                    return true
                                                })
                                                .map(item =>
                                                    <Select.Option key={item._id}
                                                        value={item._id}>{item.name}</Select.Option>)}

                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                <Form.Item key={'asset'} label={'Asset'} style={{ width: '100%' }}>
                                    {getFieldDecorator(`asset`, {
                                        rules: [{ required: false, message: `Asset is required!` }],
                                    })(<AssetSearch
                                        styleName="gx-lt-icon-search-bar-lg"
                                        placeholder="Or search any Assets..."
                                        onChange={props.searchGlobalAssetData}
                                        assetData={
                                            assetData && assetData.filter((ast) => ast.assetModel)
                                        }
                                        onSelect={(value) => {
                                            form.setFieldsValue({ asset: value })
                                            // setSelectedAssets(value)
                                        }}
                                        authUser={authUser}
                                        loading={assetSearchLoading}
                                        multiple={true}
                                    />)}
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                                <Form.Item style={{ marginTop: '25px' }}>
                                    <span style={{ display: 'flex', flexDirection: 'row' }}>
                                        <Button type="primary" htmlType="submit" loading={loading}>
                                            Generate Chart
                                        </Button>

                                    </span>
                                </Form.Item>
                            </Col>

                        </Row>
                    </Form>
                </Card>
            </Spin>
            <Card className={`gx-card-metrics`}>
                <Row gutter={[16, 16]} align="middle">
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <Select
                            style={{ width: '100%', marginBottom: 16 }}
                            placeholder="Select Chart Type"
                            value={chartType}
                            onChange={setChartType}
                            size="small"
                            disabled={!chartProcessedData || Object.keys(chartProcessedData).length === 0}
                        >
                            <Select.Option value="1">Fuel Consumption Rate (Qty / Meter)</Select.Option>
                            <Select.Option value="2">Fuel Consumption Rate (Meter / Qty)</Select.Option>
                            <Select.Option value="3">Meter Consumption</Select.Option>
                            <Select.Option value="4">Fuel Consumption</Select.Option>
                        </Select>
                    </Col>

                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>

                        <Select
                            style={{ width: '100%' }}
                            placeholder="Select Meter"
                            onChange={handleMasterUnitChage}
                            value={unit && unit._id}
                            size="small"
                        // disabled={!allUnits || allUnits.length === 0 || !chartData || Object.keys(chartData).length === 0}
                        >
                            {(allUnits || []).map(m => (
                                <Select.Option key={m._id} value={m._id}>
                                    {m.name.toUpperCase()}
                                </Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>

                        <PeriodSelector
                            handleChartGroupChage={handleChartGroupChage}
                            chartGroup={dateRange.chartGroup}
                            selectedGroup={selectedGroup}
                            handleDataGroup={handleDataGroup}
                        // disabled={!allUnits || allUnits.length === 0 || !chartData || Object.keys(chartData).length === 0}
                        />
                    </Col>
                </Row>
                {/* </Card>
            <Card className={`gx-card-metrics`}> */}
                <Divider />
                <div>
                    {unit && Object.keys(chartData).length > 0 ? (
                        <div id="chartDiv" style={{ width: "100%", height: "700px" }}></div>
                    ) : (
                        <Empty description="No data available" />
                    )}

                </div>
            </Card>
        </div>
    );
}

const mapStateToProps = ({ auth, fuel, commonData }) => {
    return {
        authUser: auth.authUser,
        loading: commonData.loading,
        mileage_report_data: fuel.mileage_report_data,
        assetFilters: commonData.assetFilters,
        assetData: commonData.assetSearchData,
        assetSearchLoading: commonData.assetSearchLoading,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        getFuelMileageReportData,
        fetchAssetFiltersData,
        searchGlobalAssetData
    };
}

const GroupChart = Form.create({ name: 'asset-group-chart' })(AssetGroupChart);
export default connect(mapStateToProps, mapDispatchToProps())(GroupChart);
